/* Lightweight page JS — variant pick, qty, sticky ATC math.
   No frameworks. Scoped to the .lux-product-page DOM. */
(function () {
  var root = document.getElementById('lux-page');
  if (!root) return;

  // Variant pick
  root.querySelectorAll('[data-variant]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      root.querySelectorAll('[data-variant]').forEach(function (b) {
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });
    });
  });

  // Quantity
  var qty = root.querySelector('#lux-qty');
  var priceNow = 58;
  function updateTotal() {
    var n = Math.max(1, parseInt(qty.value, 10) || 1);
    var total = '$' + (priceNow * n).toFixed(0);
    root.querySelectorAll('[data-cart-total]').forEach(function (el) { el.textContent = total; });
  }
  root.querySelectorAll('[data-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var delta = parseInt(btn.getAttribute('data-qty'), 10);
      qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + delta);
      updateTotal();
    });
  });
  qty && qty.addEventListener('input', updateTotal);

  // ATC stub
  root.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      btn.style.transition = 'transform 200ms';
      btn.style.transform = 'scale(.97)';
      setTimeout(function () { btn.style.transform = ''; }, 200);
      // In Shopify, this becomes a real <form action="/cart/add"> submit (theme-native).
      console.log('[demo] Add to cart — replaced with theme-native form on Shopify');
    });
  });

  // Sticky ATC visibility: show after hero ATC scrolls out of view (desktop + mobile)
  var sticky = root.querySelector('.lux-sticky-atc');
  var heroBtn = root.querySelector('.lux-hero__buyrow [data-add-to-cart]');
  if (sticky && heroBtn) {
    var lastVisible = null;
    function updateSticky() {
      var rect = heroBtn.getBoundingClientRect();
      var heroVisible = rect.bottom > 0 && rect.top < window.innerHeight;
      if (heroVisible === lastVisible) return;
      lastVisible = heroVisible;
      if (heroVisible) {
        sticky.classList.remove('is-visible');
        root.classList.remove('has-sticky-atc');
      } else {
        sticky.classList.add('is-visible');
        root.classList.add('has-sticky-atc');
      }
    }
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);
    updateSticky();
  }
  // "Back to top" button on sticky bar
  var upBtn = sticky && sticky.querySelector('.lux-sticky-atc__up');
  upBtn && upBtn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
  // "Edit choices" focuses the variant selector
  var editBtn = sticky && sticky.querySelector('.lux-sticky-atc__edit');
  editBtn && editBtn.addEventListener('click', function () {
    var variants = root.querySelector('.lux-hero__variants');
    if (variants) {
      window.scrollTo({ top: variants.getBoundingClientRect().top + window.scrollY - 100, behavior: 'smooth' });
    }
  });

  // Upgrade & Save: live total + checkbox toggle + scroll nav
  var upgrade = root.querySelector('#lux-upgrade');
  if (upgrade) {
    var scroller = upgrade.querySelector('#lux-upgrade-scroller');
    var totalEl  = upgrade.querySelector('[data-upg-total]');
    var countEl  = upgrade.querySelector('[data-upg-count]');
    var basePrice = 58;
    function recalc() {
      var checks = upgrade.querySelectorAll('.lux-upgrade__tile input[type="checkbox"]');
      var sum = basePrice;
      var n = 0;
      checks.forEach(function (cb) {
        var tile = cb.closest('.lux-upgrade__tile');
        if (cb.checked) {
          tile.classList.add('is-selected');
          n += 1;
          var p = parseFloat(tile.getAttribute('data-upg-price')) || 0;
          // FREE items (data-upg-id 'deck') don't add to total
          if (tile.querySelector('.now.free')) {
            // already free
          } else {
            sum += p;
          }
        } else {
          tile.classList.remove('is-selected');
        }
      });
      totalEl.textContent = sum.toFixed(0);
      countEl.textContent = n + (n === 1 ? ' add-on selected' : ' add-ons selected');
    }
    upgrade.querySelectorAll('.lux-upgrade__tile input[type="checkbox"]').forEach(function (cb) {
      cb.addEventListener('change', recalc);
    });
    upgrade.querySelector('[data-upg-prev]').addEventListener('click', function () {
      scroller.scrollBy({ left: -scroller.clientWidth * 0.6, behavior: 'smooth' });
    });
    upgrade.querySelector('[data-upg-next]').addEventListener('click', function () {
      scroller.scrollBy({ left: scroller.clientWidth * 0.6, behavior: 'smooth' });
    });
    recalc();
  }

  // Inline rotating review carousel
  var reviewBox = root.querySelector('#lux-inline-review');
  if (reviewBox) {
    var REVIEWS = [
      { name: 'Maya R.',   avatar: 'M', stars: 5, quote: '"We did this on a Tuesday and it was better than anything we\'d planned in months. The card deck made us actually talk. The terrarium is on our kitchen counter."' },
      { name: 'Jordan T.', avatar: 'J', stars: 5, quote: '"Bought one for my sister, kept it for myself. Ordered another for her. Made that one too. I have two now. No regrets."' },
      { name: 'Sam K.',    avatar: 'S', stars: 5, quote: '"Opened the box and immediately understood why people pay for design. Every piece is labelled. The zine is a real zine. I am being marketed to perfectly."' },
      { name: 'Devon L.',  avatar: 'D', stars: 5, quote: '"Overwatered. Classic. Texted the team, they sent a $9 refill, it\'s back. Customer service replied in 12 minutes. With plant emojis."' },
      { name: 'Alex P.',   avatar: 'A', stars: 5, quote: '"The grounding effect of making something with your hands for 45 minutes is wild. 10/10 would replace journaling with this."' }
    ];
    var idx = 0;
    function renderReview() {
      var r = REVIEWS[idx];
      reviewBox.querySelector('[data-avatar]').textContent = r.avatar;
      reviewBox.querySelector('[data-name]').textContent = r.name;
      reviewBox.querySelector('[data-quote]').textContent = r.quote;
      var stars = reviewBox.querySelector('.stars');
      stars.textContent = '★★★★★'.slice(0, r.stars) + '☆☆☆☆☆'.slice(0, 5 - r.stars);
    }
    reviewBox.querySelector('[data-rev-prev]').addEventListener('click', function () {
      idx = (idx - 1 + REVIEWS.length) % REVIEWS.length; renderReview();
    });
    reviewBox.querySelector('[data-rev-next]').addEventListener('click', function () {
      idx = (idx + 1) % REVIEWS.length; renderReview();
    });
    // Auto-rotate every 5s, pause on hover
    var rotateTimer = setInterval(function () { idx = (idx + 1) % REVIEWS.length; renderReview(); }, 5000);
    reviewBox.addEventListener('mouseenter', function () { clearInterval(rotateTimer); });
  }

  // UGC track scroll nav
  var ugc = root.querySelector('#lux-ugc-track');
  if (ugc) {
    var step = function () { return ugc.clientWidth * 0.6; };
    root.querySelector('[data-ugc-prev]') && root.querySelector('[data-ugc-prev]').addEventListener('click', function () {
      ugc.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    root.querySelector('[data-ugc-next]') && root.querySelector('[data-ugc-next]').addEventListener('click', function () {
      ugc.scrollBy({ left: step(), behavior: 'smooth' });
    });
  }
})();
